module.exports = __webpack_public_path__ + "9af684c8fd773750be3a86a68ffc1a82.png";